<template lang="pug">
  dl
    template(v-if='!selectedSku.is_denied_country')
      dt Where Can it Ship?
      dd
        p(v-if='selectedSku.is_allowed_for_worldwide_delivery') This product can be shipped worldwide.
        p(v-else-if='selectedSku.is_countries_shipping_allowed_on_ui', v-text='selectedSku.shipping_allowed_country_names.join(", ")')
        p(v-else) This product cannot be shipped to the following countries due to copyright and other region restrictions: {{ selectedSku.shipped_denied_country_names.join(', ') }}.

    template(v-if='selectedSku.is_free_shipping')
      dt
        i.icon-info-sign.u-color-muted.u-mrxs
        | Save on Shipping!
      dd
        p
          | Items over ${{ freeShippingThreshold }} may qualify for Free Standard Shipping or discount express shipping. Due to size and region limitations, only express shipping options are available for some products. Input your shipping details at checkout to see which discounted or free shipping options are available for your order.

    template(v-if='warehouseLocation')
      dt Warehouse Location
      dd(v-text='warehouseLocation')

    dt About Shipping
    dd
      p(v-if='selectedSku.is_digital_content') A URL to download this product will be emailed to you after you complete your purchase.
      div(v-else)
        p
          | Shipments over ${{ freeShippingThreshold }} get shipping fee discounts (up to 100% off). Shipping methods available to you at checkout may vary depending on size, weight, and region restrictions. #[a(href="/hc/shop/shipping_and_delivery/shipping_methods/5847b181aacd3e0b08370576" rel="nofollow") Go here] to learn more about our shipping methods &amp; their discount rates.

    //- Pre-order
    template(v-if='selectedSku.sales_method === SALES_METHOD.PRE_ORDER || (selectedSku.sales_method === SALES_METHOD.BTO && isBeforeExpectedShipAt(selectedSku))')
      dt Release Date
      dd
        | This is a pre-order product expected to release by the end of
        = ' '
        strong {{ selectedSku.format_expected_ship_at_or_extra_week }}
        br
        | Purchasers will be notified if the manufacturer changes the release date.
        br
        | Pre-orders are charged immediately upon checkout and cannot be canceled.

    //- https://github.com/tokyootakumode/com/issues/12755 緊急対応
    template(v-else-if="productId !== '54ab80946a8e0e8536748c34' && !selectedSku.is_out_of_stock && !isPreOrder(selectedSku)")
      dt Expected Shipment Date
      dd(v-if='selectedSku.is_digital_content')
        | You will be emailed automatically once your purchase is complete.
      dd(v-else-if='selectedSku.sales_method === SALES_METHOD.BTO')
        | Please allow approximately {{ getExpectedShipAtOrExtraWeek(selectedSku) }} for this special order product to become available for shipment.
        br
        | Special order items are charged immediately upon checkout and cannot be canceled.
      dd(v-else-if="isCanBulkShippingAndStock(selectedSku, access_country_code)").
        If purchased with #[a(href="https://otakumode.com/hc/shop/shipping_and_delivery/shipping_and_delivery_general/60457d33e4b27734731ae355", target="_blank") TOM Surface Mail]: expected to ship in 3-6 weeks.#[br]
        If purchased with any other shipping method: expected to ship in {{inStockExpectedShipDays}} business days.

      dd(v-else)
        | This product is expected to ship within {{inStockExpectedShipDays}} business days.
</template>

<script>
import ProductSku from '../../../../stores/schema/ProductSku';

const REGION_LOCATION = {
  Maihama: 'Japan',
  PDX: 'United States',
  Commerce: 'United States'
};

export default {
  props: ['productId', 'freeShippingThreshold'],

  computed: {
    access_country_code() {
      return window.tom.conf.access_country_code;
    },
    SALES_METHOD() {
      return ProductSku.SALES_METHOD;
    },

    selectedSku() {
      return this.$store.getters['product/skus/selectedSku'];
    },

    isDeniedCountry() {
      return this.selectedSku && this.selectedSku.is_denied_country;
    },

    warehouseLocation() {
      if (this.selectedSku && this.selectedSku.region) {
        return REGION_LOCATION[this.selectedSku.region];
      }
      return '';
    },

    inStockExpectedShipDays() {
      return ProductSku.inStockExpectedShipDays(this.selectedSku);
    }
  },

  methods: {
    isPreOrder: ProductSku.isPreOrder,
    getExpectedShipAtOrExtraWeek: ProductSku.getExpectedShipAtOrExtraWeek,
    isCanBulkShippingAndStock: ProductSku.isCanBulkShippingAndStock,
    isBeforeExpectedShipAt: ProductSku.isBeforeExpectedShipAt
  }
};
</script>
